import { withEngagingURL } from '../../../decorators'
import { useGenericRequestHandler } from '../../../handlers'
import type { ToteEngagementMode } from '../../../models'

const endpoint = 'v1/m/loop'

export interface MoteLoopPayload {
  step: number
  seenMeme: string
  mode: ToteEngagementMode
}

export function useMoteLoopMutation(moteId: string): {
  mutate: (variables: { variables: MoteLoopPayload }) => Promise<unknown>
} {
  const values = useGenericRequestHandler({
    route: endpoint + `/${moteId}`,
    method: 'POST'
  })

  //@ts-expect-error
  return withEngagingURL(values)
}
